// extracted by mini-css-extract-plugin
export default {"selectLabel":"PerformTcso_selectLabel__UBqvW"};